"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _css = _interopRequireDefault(require("@styled-system/css"));

var _styledSystem = require("styled-system");

var _polished = require("polished");

var _themeGet = require("@styled-system/theme-get");

var _Button = require("reakit/Button");

var _system = _interopRequireWildcard(require("../../utils/system"));

var _Spinner = _interopRequireDefault(require("../Spinner/Spinner"));

var _jsxRuntime = require("react/jsx-runtime");

var _variants, _variants3;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var sizes = {
  sm: 'sm',
  md: 'md',
  lg: 'lg'
};
var corners = {
  square: 'square',
  rounded: 'rounded',
  circle: 'circle'
};
var variants = {
  contained: 'contained',
  outlined: 'outlined',
  text: 'text',
  ghost: 'ghost'
};
var colors = {
  "default": 'gray.800',
  primary: 'primary.main',
  secondary: 'secondary.main',
  success: 'success',
  info: 'info',
  warning: 'warning',
  danger: 'danger'
};
var propTypes = {
  as: _propTypes.elementType,
  block: _propTypes.bool,
  children: _propTypes.node.isRequired,
  classes: (0, _propTypes.shape)({
    root: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({}), _propTypes.func]),
    startIcon: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({}), _propTypes.func]),
    endIcon: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({}), _propTypes.func]),
    loading: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({}), _propTypes.func]),
    spinner: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({}), _propTypes.func])
  }),
  corner: (0, _propTypes.oneOf)(Object.values(corners)),
  disabled: _propTypes.bool,
  endIcon: _propTypes.node,
  focusable: _propTypes.bool,
  loading: _propTypes.bool,
  loadingText: _propTypes.node,
  size: (0, _propTypes.oneOf)(Object.values(sizes)),
  spinner: _propTypes.node,
  startIcon: _propTypes.node,
  variant: (0, _propTypes.oneOf)(Object.values(variants)),
  variantColor: _propTypes.string
};
var defaultProps = {
  as: undefined,
  block: false,
  classes: {
    endIcon: null,
    loading: null,
    root: null,
    spinner: null,
    startIcon: null
  },
  corner: corners.rounded,
  disabled: false,
  endIcon: null,
  focusable: undefined,
  loading: false,
  loadingText: null,
  size: sizes.md,
  spinner: null,
  startIcon: null,
  variant: variants.contained,
  variantColor: 'default'
};
var Button = (0, _system["default"])(_Button.Button)({
  label: 'Button'
}, (0, _css["default"])({
  alignItems: 'center',
  appearance: 'none',
  backgroundColor: 'transparent',
  border: '1px',
  borderColor: 'transparent',
  boxSizing: 'border-box',
  cursor: 'pointer',
  display: 'inline-flex',
  fontFamily: 'body',
  fontWeight: 'normal',
  justifyContent: 'center',
  lineHeight: 'base',
  overflow: 'visible',
  position: 'relative',
  textAlign: 'center',
  textDecoration: 'none',
  textTransform: 'uppercase',
  transition: 'background-color 0.5s ease',
  userSelect: 'none',
  verticalAlign: 'middle',
  whiteSpace: 'nowrap',
  p: 0,
  m: 0
}), (0, _styledSystem.variant)({
  scale: 'button',
  prop: 'cSize',
  variants: (_variants = {}, _defineProperty(_variants, sizes.sm, {
    fontSize: 'xs',
    height: 8,
    minWidth: 8,
    px: 3
  }), _defineProperty(_variants, sizes.md, {
    fontSize: 'sm',
    height: 10,
    minWidth: 10,
    px: 4
  }), _defineProperty(_variants, sizes.lg, {
    fontSize: 'md',
    height: 12,
    minWidth: 12,
    px: 6
  }), _variants)
}), function (props) {
  var _variants2;

  var colorPath = "colors.".concat(colors[props.variantColor] || props.variantColor);
  var color = (0, _themeGet.themeGet)(colorPath, (0, _themeGet.themeGet)("colors.".concat(colors["default"]))(props))(props);
  return (0, _styledSystem.variant)({
    scale: 'button',
    variants: (_variants2 = {}, _defineProperty(_variants2, variants.contained, {
      bg: color,
      color: 'white',
      ':hover': {
        bg: (0, _polished.darken)(0.15, color)
      }
    }), _defineProperty(_variants2, variants.outlined, {
      color: color,
      borderColor: color,
      ':hover': {
        bg: (0, _polished.rgba)(color, 0.05)
      }
    }), _defineProperty(_variants2, variants.text, {
      color: color,
      ':hover': {
        bg: (0, _polished.rgba)(color, 0.08)
      }
    }), _defineProperty(_variants2, variants.ghost, {
      color: color,
      bg: (0, _polished.rgba)(color, 0.08),
      ':hover': {
        bg: (0, _polished.rgba)(color, 0.2)
      }
    }), _variants2)
  });
}, (0, _styledSystem.variant)({
  scale: 'button',
  prop: 'corner',
  variants: (_variants3 = {}, _defineProperty(_variants3, corners.square, {}), _defineProperty(_variants3, corners.rounded, {
    borderRadius: 'md'
  }), _defineProperty(_variants3, corners.circle, {
    borderRadius: 'full'
  }), _variants3)
}), function (_ref) {
  var disabled = _ref.disabled;
  return disabled && {
    opacity: 0.6
  };
}, function (_ref2) {
  var block = _ref2.block;
  return block && {
    width: '100%'
  };
}, (0, _system.classesStyles)('root'));
var iconFonts = {
  sm: 18,
  md: 20,
  lg: 22
};
var Icon = (0, _base["default"])("span", process.env.NODE_ENV === "production" ? {
  target: "ef6zx612"
} : {
  target: "ef6zx612",
  label: "Icon"
})(function (_ref3) {
  var buttonSize = _ref3.buttonSize;
  return {
    display: 'inherit',
    '> svg': {
      fontSize: iconFonts[buttonSize] || 20
    }
  };
});
var StartIcon = ( /*#__PURE__*/0, _base["default"])(Icon, process.env.NODE_ENV === "production" ? {
  target: "ef6zx611"
} : {
  target: "ef6zx611",
  label: "StartIcon"
})(function (_ref4) {
  var _ref4$hasText = _ref4.hasText,
      hasText = _ref4$hasText === void 0 ? true : _ref4$hasText;
  return hasText && (0, _css["default"])({
    ml: -1,
    mr: 2
  });
}, (0, _system.classesStyles)('startIcon'), (0, _system.classesStyles)('loading'));
var EndIcon = ( /*#__PURE__*/0, _base["default"])(Icon, process.env.NODE_ENV === "production" ? {
  target: "ef6zx610"
} : {
  target: "ef6zx610",
  label: "EndIcon"
})((0, _css["default"])({
  ml: 2,
  mr: -1
}), (0, _system.classesStyles)('endIcon'));
var Component = /*#__PURE__*/(0, _react.forwardRef)(function (_ref5, ref) {
  var children = _ref5.children,
      disabled = _ref5.disabled,
      endIcon = _ref5.endIcon,
      loading = _ref5.loading,
      loadingText = _ref5.loadingText,
      size = _ref5.size,
      spinner = _ref5.spinner,
      startIcon = _ref5.startIcon,
      props = _objectWithoutProperties(_ref5, ["children", "disabled", "endIcon", "loading", "loadingText", "size", "spinner", "startIcon"]);

  var iconProps = {
    classes: props.classes,
    buttonSize: size
  };
  var spinnerClasses = {
    root: function root(innerProps) {
      return (0, _system.classesStyles)('spinner')(_objectSpread(_objectSpread({}, innerProps), {}, {
        classes: props.classes
      }));
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Button, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    cSize: size,
    disabled: disabled || loading,
    role: props.as ? 'button' : undefined,
    children: loading ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StartIcon, _objectSpread(_objectSpread({}, iconProps), {}, {
        hasText: loadingText !== null,
        children: spinner || /*#__PURE__*/(0, _jsxRuntime.jsx)(_Spinner["default"], {
          size: "sm",
          color: "inherit",
          classes: spinnerClasses
        })
      })), loadingText]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [startIcon && /*#__PURE__*/(0, _jsxRuntime.jsx)(StartIcon, _objectSpread(_objectSpread({}, iconProps), {}, {
        children: startIcon
      })), children, endIcon && /*#__PURE__*/(0, _jsxRuntime.jsx)(EndIcon, _objectSpread(_objectSpread({}, iconProps), {}, {
        children: endIcon
      }))]
    })
  }));
});
Component.displayName = 'Button';
Component.propTypes = propTypes;
Component.defaultProps = defaultProps;
var _default = Component;
exports["default"] = _default;

//# sourceMappingURL=Button.js.map